import * as yup from 'yup'

import { VatVisibilityEnum } from './helpers'

export const offerFormSchema = yup.object({
  clientId: yup.string().required('Поле "Клиент" обязательно для заполнения'),
  clientContactName: yup.string().notRequired(),
  clientContactNamePosition: yup.string().notRequired(),
  clientDivision: yup
    .string()
    .required('Поле "Объект" обязательно для заполнения'),
  fuelPrice: yup
    .number()
    .min(0)
    .required('Поле "Цена ГСМ" обязательно для заполнения'),
  personDeliveryPrice: yup
    .number()
    .min(0)
    .required('Поле "Стоимость доставки персонала" обязательно для заполнения'),
  partDeliveryPrice: yup
    .number()
    .min(0)
    .required('Поле "Стоимость доставки запчастей" обязательно для заполнения'),
  personnelHouseholdServicesCost: yup.number().min(0).notRequired(),
  accommodationPrice: yup.number().min(0).notRequired(),
  foodPrice: yup.number().min(0).notRequired(),
  createDate: yup.string().required(),
  validityDaysCount: yup
    .number()
    .min(0)
    .required('Поле "Срок действия КП" обязательно для заполнения'),
  minRentPeriod: yup
    .number()
    .min(0)
    .required('Поле "Минимальный срок аренды" обязательно для заполнения'),
  season: yup.string().required(),
  dailyMedCheckCost: yup.number().min(0),
  personalBenefits: yup.boolean().notRequired(),
  vatVisibility: yup
    .string()
    .oneOf([
      VatVisibilityEnum.VAT,
      VatVisibilityEnum.NO_VAT,
      VatVisibilityEnum.ALL,
    ])
    .required(),
})
